import { AdminApi } from "../../service";

export interface WarehouseStock {
  stockId: number;
  campId: number;
  campName?: string | null;
  vehicleId: string;
  assetNo?: number | null;
  qr: string;
  model: string;
  incomeAt?: number | null;
  matchedHistoryId?: number | null;
  selectable: boolean;
}

export interface WarehouseHistory {
  historyId: number;
  campId: number;
  campName?: string | null;
  vehicleId: string;
  assetNo?: number | null;
  qr: string;
  model: string;
  incomeAt?: number | null;
  outgoAt?: number | null;
  historyType: string;
  matchedStockId?: number | null;
}

export interface WarehouseContext {
  vehicleId: string;
  qr: string;
  assetNo: number | null;
  status: string;
  available: boolean;
  riding: boolean;
  revision: string;
  stocks: WarehouseStock[];
  histories: WarehouseHistory[];
  issues: { code: string; message: string }[];
  suggestedStockIds: number[];
  canStockOut: boolean;
  correctionRequired: boolean;
}

export interface WarehouseStockOutRequest {
  requestId: string;
  expectedRevision: string;
  assetNo: number;
  stockIds: number[];
  expectedHistoryIds: number[];
  physicalConfirmed: boolean;
  correctionConfirmed: boolean;
  reason: string;
}

export interface WarehouseStockOutResult {
  requestId: string;
  historyId: string;
  mode: "STOCK_OUT" | "CORRECTION";
  status: "CargoForReady";
  available: false;
  removedStockIds: number[];
  closedHistoryIds: number[];
  unresolvedHistoryIds: number[];
}

export async function getWarehouseContext(vehicleId: string): Promise<WarehouseContext> {
  return AdminApi.get<WarehouseContext>(`scooters/${encodeURIComponent(vehicleId)}/warehouse-context`, { timeout: 15000 })
    .then((response) => response.data);
}

export async function stockOutVehicle(
  vehicleId: string,
  request: WarehouseStockOutRequest
): Promise<WarehouseStockOutResult> {
  return AdminApi.post<WarehouseStockOutResult>(`scooters/${encodeURIComponent(vehicleId)}/stock-out`, request, { timeout: 30000 })
    .then((response) => response.data);
}
